<template>
  <div class="kk__error">
    <div class="kk__error--content">
      <div class="kk__error--icon">
        <i :class="`icon-${iconType}`"></i>
      </div>
      <h2>{{ error.summary }}</h2>
      <p>{{ error.detail }}</p>
      <div class="kk__error--action">
        <!-- Dynamically render buttons based on error.buttons array -->
        <div v-if="error.buttons && error.buttons.length" class="kk__error--action">
          <div class="kk__error--action--yesno">
            <button
              v-for="(button, index) in error.buttons"
              :key="index"
              :class="[{ 'btn-focus': focusedButton === index }, getClass(button.type)]"
              @click="executeAction(button.action)"
            >
              {{ button.text }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import hotkeys from "hotkeys-js";
import DesignerMixin from "../process-design/DesignerMixin";
import { HotkeyScopes } from "../../utils/constants";
export default {
  mixins: [DesignerMixin],
  data() {
    return {
      previousScope: null,
      focusedButton: 0, // Default focus on confirm button
    };
  },
  computed: {
    error() {
      return this.$store.state.pdesign.error;
    },
    iconType() {
      return this.$store.state.pdesign.error.type ?? "Error";
    },
  },
  mounted() {
    this.setScope();
  },
  methods: {
    getClass(type) {
      if (type === "confirm") {
        return "kk__error--action--yes";
      } else if (type === "cancel") {
        return "kk__error--action--no";
      }
      return "kk__error--action--ok";
    },
    executeAction(action) {
      if (typeof action === "function") {
        action(); // Call the provided action
      }
      this.closeError(); // Close the error box after action
    },

    closeError() {
      this.focusedButton = 1;
      this.$store.dispatch("pdesign/setError", {
        show: null,
        type: "inof",
        summary: null,
        detail: null,
        buttons: [], // Reset buttons
      }); // Clear the error in Vuex
      this.resetScope();
    },

    resetScope() {
      if (hotkeys.getScope() === HotkeyScopes.ErrorBox) {
        hotkeys.setScope(this.previousScope ?? HotkeyScopes.All);
        hotkeys.unbind("enter, tab, escape, right, left,shift+tab", HotkeyScopes.ErrorBox);
      }
    },
    setScope() {
      if (hotkeys.getScope() !== HotkeyScopes.ErrorBox) {
        this.previousScope = hotkeys.getScope();
        hotkeys.setScope(HotkeyScopes.ErrorBox);
      }
      hotkeys("enter, tab, escape, right, left,shift+tab", HotkeyScopes.ErrorBox, (e, handler) => {
        e.preventDefault();
        const focusedAction = this.error.buttons[this.focusedButton]?.action;
        switch (handler.key) {
          case "escape":
            this.closeError();
            break;
          case "right":
          case "left":
          case "tab":
          case "shift+tab":
            this.toggleFocus();
            break;
          case "enter":
            // Trigger the action of the focused button when "Enter" is pressed
            this.executeAction(focusedAction);
            break;
        }
      });
    },
    toggleFocus() {
      this.focusedButton = this.focusedButton === 0 ? 1 : 0;
    },
  },
};
</script>

<style scoped lang="less">
@import "../../assets/styles/variables.less";

.kk {
  &__error {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 250;
    font-size: 12px;
    width: 300px;
    height: 310px;
    background: #b9d1f3;
    border-radius: 8px;
    text-align: center;
    overflow: hidden;
    padding-top: 10px;

    &--content {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;
      background-color: #e7f0fc; /* Light blue */
      padding: 0px 10px;
      height: 100%;
      line-height: 2;
      h2 {
        margin-bottom: -20px;
      }
    }

    &--icon {
      i {
        font-size: 30px;
        background: rgba(255, 255, 255, 0.35);
        padding: 12px;
        border-radius: 50%;
      }
    }
    &--action {
      width: 100%;
      text-align: center;

      &--yesno {
        display: flex;
        justify-content: space-evenly;
      }

      &--no,
      &--yes {
        background: rgba(152, 173, 202, 0.53);
      }
      &--yes,
      &--ok,
      &--no {
        border-radius: 4px;
        width: 97.52px;
        font-size: 14px;
      }
      &--ok {
        color: white;
        background: #0056ce;
        width: 161px;
      }
    }
  }
}

.btn-focus {
  background: rgba(0, 86, 206, 1);
  color: #fff;
}
</style>
